(function () {
  const STORAGE_PREFIX = 'mm-entry-popup-dismissed:';

  class MmEntryPopup {
    constructor(root) {
      this.root = root;
      this.dialogComponent = root.matches?.('dialog-component')
        ? root
        : root.querySelector('dialog-component');
      this.dialog = root.querySelector('[data-mm-entry-popup-dialog]');
      this.video = root.querySelector('[data-mm-entry-popup-video]');
      this.playButton = root.querySelector('[data-mm-entry-popup-play]');
      this.sectionId = root.dataset.sectionId;
      this.delay = Number(root.dataset.mmDelay || 0) * 1000;
      this.dismissDays = Number(root.dataset.mmDismissDays || 7);
      this.autoOpen = root.dataset.mmAutoOpen !== 'false';
      this.storageKey = STORAGE_PREFIX + this.sectionId;
      this.openTimer = null;
      this.onPlayClick = this.handlePlayClick.bind(this);
      this.onVideoEnded = this.handleVideoEnded.bind(this);
      this.onDialogClose = this.handleDialogClose.bind(this);
      this.onSectionSelect = this.handleSectionSelect.bind(this);
      this.onSectionDeselect = this.handleSectionDeselect.bind(this);

      this.init();
    }

    init() {
      if (this.playButton) {
        this.playButton.addEventListener('click', this.onPlayClick);
      }

      if (this.video) {
        this.video.addEventListener('ended', this.onVideoEnded);
      }

      if (this.dialogComponent) {
        this.dialogComponent.addEventListener('dialog:close', this.onDialogClose);
      }

      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:section:select', this.onSectionSelect);
        document.addEventListener('shopify:section:deselect', this.onSectionDeselect);
      }

      if (this.autoOpen && (window.Shopify?.designMode || !this.isDismissed())) {
        this.openTimer = window.setTimeout(() => this.open(), this.delay);
      }
    }

    destroy() {
      window.clearTimeout(this.openTimer);
      if (this.playButton) {
        this.playButton.removeEventListener('click', this.onPlayClick);
      }
      if (this.video) {
        this.video.removeEventListener('ended', this.onVideoEnded);
      }
      if (this.dialogComponent) {
        this.dialogComponent.removeEventListener('dialog:close', this.onDialogClose);
      }
      document.removeEventListener('shopify:section:select', this.onSectionSelect);
      document.removeEventListener('shopify:section:deselect', this.onSectionDeselect);
      this.resetVideo();
    }

    async open() {
      if (!this.dialogComponent) return;
      await customElements.whenDefined('dialog-component');
      if (typeof this.dialogComponent.showDialog === 'function') {
        this.dialogComponent.showDialog();
      }
    }

    close() {
      if (!this.dialogComponent || typeof this.dialogComponent.closeDialog !== 'function') return;
      this.dialogComponent.closeDialog();
    }

    handleDialogClose() {
      this.resetVideo();
      if (!window.Shopify?.designMode) {
        this.setDismissed();
      }
    }

    handlePlayClick(event) {
      event.preventDefault();
      if (!this.video) return;

      if (this.video.paused) {
        this.video.muted = false;
        this.video.play().catch(() => {
          this.video.muted = true;
          this.video.play().catch(() => {});
        });
        this.root.classList.add('mm-entry-popup--playing');
      } else {
        this.resetVideo();
      }
    }

    handleVideoEnded() {
      this.resetVideo();
    }

    resetVideo() {
      if (this.video) {
        this.video.pause();
        this.video.currentTime = 0;
      }
      this.root.classList.remove('mm-entry-popup--playing');
    }

    pauseVideo() {
      this.resetVideo();
    }

    isDismissed() {
      try {
        const raw = window.localStorage.getItem(this.storageKey);
        if (!raw) return false;
        if (this.dismissDays <= 0) return true;
        const dismissedAt = Number(raw);
        if (!dismissedAt) return false;
        return Date.now() - dismissedAt < this.dismissDays * 86400000;
      } catch (error) {
        return false;
      }
    }

    setDismissed() {
      try {
        window.localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (error) {}
    }

    handleSectionSelect(event) {
      if (event.detail?.sectionId !== this.sectionId) return;
      this.open();
    }

    handleSectionDeselect(event) {
      if (event.detail?.sectionId !== this.sectionId) return;
      this.close();
    }
  }

  const instances = new WeakMap();

  function mount(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new MmEntryPopup(root));
  }

  function unmount(root) {
    const instance = instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  }

  function initAll() {
    document.querySelectorAll('[data-mm-entry-popup]').forEach(mount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.('[data-mm-entry-popup]') || event.target;
    if (root?.matches?.('[data-mm-entry-popup]')) mount(root);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target?.querySelector?.('[data-mm-entry-popup]') || event.target;
    if (root?.matches?.('[data-mm-entry-popup]')) unmount(root);
  });
})();
